import axiosInstance from '../../api/axios';

const baseUrl = '/chapters';

const ChapterService = {
  listAllChapters: async () => {
    try {
      const response = await axiosInstance.get(baseUrl);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch chapters');
      }
    } catch (error) {
      throw error;
    }
  },
  getChaptersByCourse: async (courseId) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/course/${courseId}`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch chapters by course');
      }
    } catch (error) {
      throw error;
    }
  },

  showChapterDetails: async (id) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/${id}`);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  },

  createNewChapters: async (courseId, chaptersData) => {
    try {
      const response = await axiosInstance.post(baseUrl, { course_id: courseId, chapters: chaptersData });
      if (response.data.success) {
        return response.data.data;
        } else {
        throw new Error('Failed to create chapters');
      }
    } catch (error) {
      throw error;
    }
  },

  updateChapterDetails: async (id, data) => {
    try {
      const response = await axiosInstance.put(`${baseUrl}/${id}`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to update chapter details');
      }
    } catch (error) {
      throw error;
    }
  },
  deleteChapter: async (id) => {
    try {
      const response = await axiosInstance.delete(`${baseUrl}/${id}`);
      if (response.status === 204) {
        return { success: true };
      } else {
        throw new Error('Failed to delete chapter');
      }
    } catch (error) {
      throw error;
    }
  },

  getChaptersByEducationalLevel: async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/edu`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch chapters by educational level');
      }
    } catch (error) {
      throw error;
    }
  },
};

export default ChapterService;